import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsSettings.styles'

type Props = {}

function ReportsSettingsPage(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'Settings')

  return (
    <div className={classes.root} data-testid={p('title')}>
      {pt('title')}
    </div>
  )
}

export default ReportsSettingsPage
